export function getEnv(key: string): string | undefined {
  return (window as any).__ENV__?.[key] || process.env[key];
}
